import React from 'react'
import PropTypes from 'prop-types'
import Alert, { AlertControls, AlertMessage } from 'components/Alert'
import { Text } from 'components/Box'
import Button from 'components/Button'

import circleHold from 'icons/circle-hold.png'
import circleHold2x from 'icons/circle-hold@2x.png'
import circleHold3x from 'icons/circle-hold@3x.png'

export const localStorageKey = 'hasSeenClosePrototypeAlert'

const ClosePrototypeAlert = props => (
  <Alert {...props}>
    <AlertMessage>
      <Text textAlign="center">
        <img
          alt="hold to close"
          src={circleHold}
          srcSet={`${circleHold2x} 2x, ${circleHold3x} 3x`}
        />
      </Text>
      <Text textAlign="center" style={{ fontWeight: 'bold' }}>
        Tap and hold anywhere on the screen to leave the&nbsp;Prototype view
      </Text>
    </AlertMessage>
    <AlertControls>
      <Button
        variant="primary"
        style={{ width: '100%' }}
        onClick={props.onCancel}>
        OK
      </Button>
    </AlertControls>
  </Alert>
)

ClosePrototypeAlert.propTypes = {
  onCancel: PropTypes.func.isRequired,
}

export default ClosePrototypeAlert
